module.exports = "/assets/dist/images/engine.svg?58c3c453cd43ba5a005b6065c166a364";